module.exports = __webpack_public_path__ + "img/Transfers.f27d1a58.jpg";